import React from 'react'

const Chapter02 = () => {
    return (
        <div >
            <h3 className='title'>Capítulo 02</h3>
            <div className='description'>Com o tempo, sua fama se espalhou por todo o reino. Chamado a servir o Rei Alden, Sir Eliot embarcou em missões perigosas, enfrentando monstros terríveis e desvendando mistérios que ameaçavam a paz. Seus feitos heroicos se tornaram lendas, e seu nome era sussurrado com reverência e gratidão por aqueles que ele salvava.</div>

        </div>
    )
}

export default Chapter02